import { render } from "./PlaceSearch.vue?vue&type=template&id=532b979b&scoped=true"
import script from "./PlaceSearch.vue?vue&type=script&lang=js"
export * from "./PlaceSearch.vue?vue&type=script&lang=js"

import "./PlaceSearch.vue?vue&type=style&index=0&id=532b979b&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532b979b"]])

export default __exports__